import { ref, watch } from "vue";
import { getRefs } from "./utils";
import classNames from "classnames/dedupe";

interface HeaderProps {
  rootEl: HTMLElement;
}

const Header = (props: HeaderProps) => {
  let lastScrollY = window.scrollY;
  let lastDirection = 0;
  let lastChangeY = window.scrollY;
  const threshold = 100;

  window.addEventListener("scroll", () => {
    const header = props.rootEl;
    const scrollY = window.scrollY;
    const direction = scrollY > lastScrollY ? 1 : -1;

    if (direction !== lastDirection) {
      lastChangeY = lastScrollY;
      lastDirection = direction;
    }

    if (direction === 1 && scrollY - lastChangeY > threshold) {
      header.classList.add("hidden");
    } else if (direction === -1 && lastChangeY - scrollY > threshold) {
      header.classList.remove("hidden");
    }

    if (scrollY > 0) {
      header.classList.add("shadow");
    } else {
      header.classList.remove("shadow");
    }

    lastScrollY = scrollY;
  });
};

const init = () => {
  const headers = document.querySelectorAll<HTMLElement>("[h-comp='header']");

  for (const header of headers) {
    Header({ rootEl: header });
  }
};

init();
